<template>
  <HeaderPages />
  <section class="section_header_full_pages">
    <div class="box_img_brand_project">
      <img
        src="@/assets/project/aladari/aladari.png"
        class="img_brand_project"
        alt="aladari"
      />
    </div>
    <div class="waves_full_pages"></div>
    <div class="container_text_full_pages">
      <h1 class="title_home">
        <span class="title_home_4">Aladari<br /></span>
      </h1>
      <div class="box_button_brifing_full_pages">
        <div class="box_button_v2">
          <button class="button_v1" data-action="toggleBig">
            Оставить заявку
          </button>
        </div>
      </div>
    </div>
  </section>
  <section class="section_main_info_project">
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="font_2_4_700_Kreadon">2024</p>
      </div>
      <div class="box_main_info_project_right">
        <p class="font_2_4_700_Kreadon">Aladari</p>
      </div>
    </div>
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">
          <!-- Аналитика<br /> -->
          <!-- UX/UI дизайн<br /> -->
          Backend <BR />
          &nbsp;
          <BR />
          Frontend
          <BR />
          &nbsp;
          <BR />
          DevOps
        </p>
      </div>
      <div class="box_main_info_project_right">
        <p class="subtext_services_design">
          Торговый дом «Шкуренко» – крупная компания, занимающаяся производством
          и дистрибуцией продукции под брендом Aladari. Целью проекта было
          создание интерактивной платформы для проведения рекламной кампании с
          элементами геймификации.
        </p>
      </div>
    </div>
    <!-- <div class="container_main_info_project">
      <div class="box_main_info_project_left"></div>
      <div class="box_main_info_project_right">
        <button class="button_light">Сайт</button>
      </div>
    </div> -->
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">Цели</p>
      </div>
      <div class="box_main_info_project_right">
        <p class="subtext_services_design">
          Создать интерактивную платформу, где пользователи могут участвовать в
          рекламной кампании, получать бонусные баллы за покупки, участвовать в
          розыгрышах и обменивать накопленные баллы на призы.
        </p>
      </div>
    </div>
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">Задачи</p>
      </div>
      <div class="box_main_info_project_right">
        <ul class="list_articles subtext_services_design">
          <li>Разработать удобный и интуитивно понятный интерфейс платформы</li>
        </ul>
        <ul class="list_articles subtext_services_design">
          <li>
            Реализовать функционал сканирования чеков для поиска определенной
            продукции
          </li>
        </ul>
        <ul class="list_articles subtext_services_design">
          <li>Разработать колесо фортуны с возможностью выиграть призы</li>
        </ul>
        <ul class="list_articles subtext_services_design">
          <li>
            Ввести систему бонусных баллов и дополнительных прокрутов за
            активность
          </li>
        </ul>
        <ul class="list_articles subtext_services_design">
          <li>Создать каталог продукции с возможностью просмотра товаров</li>
        </ul>
        <ul class="list_articles subtext_services_design">
          <li>
            Разработать административную панель с детализированными отчетами по
            пользователям
          </li>
        </ul>
        <ul class="list_articles subtext_services_design">
          <li>
            Интегрировать SMS API для удобной регистрации, авторизации и
            восстановления пароля
          </li>
        </ul>
      </div>
    </div>
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">Решение</p>
      </div>
      <div class="box_main_info_project_right">
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular color_violet">01</p>
          <p class="subtext_services_design">
            <span class="fatty_font"> Функция сканирования чеков</span> <BR />
            &nbsp;
            <BR />Реализован механизм сканирования чеков, который автоматически
            находит указанную продукцию и начисляет бонусные баллы
            пользователям.
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular color_violet">02</p>
          <p class="subtext_services_design">
            <span class="fatty_font">Анимированное колесо фортуны</span>
            <BR />
            &nbsp;
            <BR />
            Создана геймифицированная механика розыгрыша призов, где
            пользователи могут использовать накопленные баллы для прокрута
            колеса фортуны.
          </p>
        </div>
      </div>
    </div>
    <div class="container_slaider_project">
      <button class="custom-prev">
        <img
          class="arrow_left_slider"
          src="@/assets/elements/arrow_right.svg"
          alt="стрелка"
        />
      </button>

      <button class="custom-next">
        <img
          class="arrow_right_slider"
          src="@/assets/elements/arrow_right.svg"
          alt="стрелка"
        />
      </button>
      <swiper
        :modules="modules"
        :slides-per-view="1"
        loop="true"
        class="mySwiper"
        :navigation="{
          nextEl: '.custom-next',
          prevEl: '.custom-prev',
        }"
      >
        <swiper-slide v-for="(slide, index) in slides" :key="index">
          <img :src="slide" class="slide-content" alt="слайд проекта" />
        </swiper-slide>
      </swiper>
    </div>

    <div class="container_main_info_project">
      <div class="box_main_info_project_left"></div>
      <div class="box_main_info_project_right">
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular color_violet">03</p>
          <p class="subtext_services_design">
            <span class="fatty_font">Бонусная система</span>
            <BR />
            &nbsp;
            <BR />
            Начисление баллов за покупки и выполнение дополнительных заданий
            мотивирует пользователей к активному взаимодействию с платформой.
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular color_violet">04</p>
          <p class="subtext_services_design">
            <span class="fatty_font">Каталог продукции</span>
            <BR />
            &nbsp;
            <BR />
            Разработан интерактивный каталог товаров, где пользователи могут
            ознакомиться с продукцией торгового дома «Шкуренко».
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular color_violet">05</p>
          <p class="subtext_services_design">
            <span class="fatty_font">
              Административная панель с отчетностью</span
            >
            <BR />
            &nbsp;
            <BR />
            В админ-панели доступна полная статистика пользователей, их
            активности, начисленных и потраченных баллов, а также подробная
            информация о сканируемых чеках.
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular color_violet">06</p>
          <p class="subtext_services_design">
            <span class="fatty_font">Интеграция SMS API</span>
            <BR />
            &nbsp;
            <BR />
            Для удобства пользователей внедрена система регистрации и
            авторизации через SMS-код, а также механизм восстановления пароля.
          </p>
        </div>
      </div>
    </div>
    <swiper
      :modules="modules"
      :slides-per-view="slidesPerView"
      loop="true"
      class="mySwiper_2"
    >
      <swiper-slide v-for="(slides_2, index) in slides_2" :key="index">
        <img :src="slides_2" class="simg_project" alt="слайд проекта" />
      </swiper-slide>
    </swiper>
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">Результат</p>
      </div>
      <div class="box_main_info_project_right">
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular">-</p>
          <p class="subtext_services_design">
            Геймифицированная платформа, привлекающая пользователей к участию в
            рекламной кампании
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular">-</p>
          <p class="subtext_services_design">
            Полностью автоматизированный процесс – от регистрации до получения
            бонусов и розыгрышей
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular">-</p>
          <p class="subtext_services_design">
            Интерактивное колесо фортуны с персонализированными призами
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular">-</p>
          <p class="subtext_services_design">
            Упрощенная регистрация и авторизация с помощью SMS-кодов
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular">-</p>
          <p class="subtext_services_design">
            Аналитическая панель для бизнеса, позволяющая отслеживать поведение
            пользователей и эффективность рекламной кампании
          </p>
        </div>
      </div>
    </div>
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">Команда</p>
      </div>
      <div class="box_main_info_project_right_row">
        <ul class="ul_team subtext_services_design">
          <span class="color_violet">Команда</span>
          <li>Frontend и Backend: Ражев Дмитрий</li>
          <li>DevOps: Кошелев Ростислав</li>
        </ul>
      </div>
    </div>
  </section>
  <SectionBlog />
  <SectionProjects />
  <FooterPages />
</template>
<script>
import { useHead } from "@vueuse/head";
import { ref, onMounted } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

import HeaderPages from "../permanent/HeaderPages.vue";
import FooterPages from "../permanent/FooterPages.vue";
import SectionBlog from "../ui/SectionBlog.vue";
import SectionProjects from "../ui/SectionProjects.vue";
import slide_1 from "@/assets/project/aladari/Aladari_slide_1.webp";
import slide_2 from "@/assets/project/aladari/Aladari_slide_2.webp";
import slide_3 from "@/assets/project/aladari/Aladari_slide_3.webp";

import slide_1_m from "@/assets/project/aladari/Aladari_slide_1_m.webp";
import slide_2_m from "@/assets/project/aladari/Aladari_slide_2_m.webp";
import slide_3_m from "@/assets/project/aladari/Aladari_slide_3_m.webp";

export default {
  components: {
    Swiper,
    SwiperSlide,
    HeaderPages,
    FooterPages,
    SectionBlog,
    SectionProjects,
  },

  setup() {
    useHead({
      title:
        "Aladari – Разработка интерактивной платформы с бонусной системой и геймификацией",
      meta: [
        {
          name: "description",
          content:
            "Создание цифровой платформы Aladari для проведения рекламных кампаний с элементами геймификации. Разработка функционала сканирования чеков, бонусной системы, колеса фортуны и административной панели. Интерактивное вовлечение пользователей и автоматизация процессов.",
        },
      ],
    });
    const slides = [slide_1, slide_2, slide_3];
    const slides_2 = [slide_1_m, slide_2_m, slide_3_m];

    const slidesPerView = ref(3);

    const updateSlidesPerView = () => {
      if (window.innerWidth <= 767) {
        slidesPerView.value = 2;
      } else {
        slidesPerView.value = 3;
      }
    };
    onMounted(() => {
      updateSlidesPerView();
      window.addEventListener("resize", updateSlidesPerView);
    });
    return {
      slides,
      slides_2,
      updateSlidesPerView,
      slidesPerView,
      modules: [Navigation],
    };
  },
};
</script>
<style scoped>
.container_main_info_project {
  height: fit-content;
}
.section_main_info_project {
  gap: 2.5rem;
}

.section_header_full_pages {
  background: linear-gradient(
    160.89deg,
    rgb(225, 61, 61) 0.279%,
    rgb(227, 223, 223) 60.681%
  );
}
.img_brand_project {
  width: 23.2rem;
  height: 21.2rem;
}
.box_img_brand_project {
  position: absolute;
  right: 6.5rem;
  top: 4.5rem;
}
.simg_project {
  height: 37rem;
  border-radius: 1.7rem;
  box-shadow: 0.7rem 0.7rem 2rem -0.8rem rgba(71, 86, 163, 0.4);
  background: rgb(245, 247, 255);
}
.fatty_font {
  font-family: Kreadon-Bold !important;
}
.mySwiper_2 {
  padding-bottom: 4rem;
}
@media (max-width: 767px) {
  .container_text_full_pages {
    padding: 11rem 2rem 4.5rem 2rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .section_header_full_pages {
    height: 51.36rem;
  }
  .title_home {
    z-index: 0;
  }
  .img_brand_project {
    width: 22.45rem;
    height: 20.91rem;
  }
  .box_img_brand_project {
    position: absolute;
    right: 2rem;
    top: 19rem;
  }
  .simg_project {
    height: 28rem;
    box-shadow: 1.27rem 1.27rem 3.64rem -1.45rem rgba(71, 86, 163, 0.4);
  }
  .mySwiper_2 {
    padding-left: 1.5rem;
    padding-bottom: 4rem;
  }
  .container_main_info_project {
    flex-direction: column;
  }
  .ul_team .color_violet {
    display: none;
  }
  .font_1_400_Kreadon_Regular {
    line-height: 1.27rem;
  }
  .container_slaider_project {
    margin: 0rem;
  }
}
</style>
